<template>
  <div>
    <p>{{$t('acessProfileTranslateUpdate.describe')}}</p>

    <b-table striped :fields="fields" :items="items" responsive>
      <template v-slot:cell(reportName)="row">
        <p>{{ row.item.reportName }}</p>
      </template>
      <template v-slot:cell(active)="row">
        <b-form-checkbox
          :id="`activate-report-${row.index}`"
          switch
          @change="activateDeactivateReport(row.item._id, row.item.active)"
          v-model="row.item.active"
          title="Ativa Relatório"
        >
        </b-form-checkbox>
      </template>
    </b-table>
  </div>
</template>

<script>
import api from '../../../../services/api';

export default {
  name: 'modalReportProfile',

  data: () => ({
    fields: [],
    items: [],
    userAuth: null,
    reportsProfile: [],
  }),

  props: {
    profile: {
      type: Object,
    },
  },

  methods: {
    async activateDeactivateReport(id, active) {
      if (active) {
        await this.activateReport(id);
      } else {
        await this.deactivateReport(id);
      }
    },

    async deactivateReport(id) {
      const array = await this.getReportsForProfile();

      let removeId;

      for (let i = 0; i < array.reportsProfile.length; i += 1) {
        if (array.reportsProfile[i].profileId === this.profile._id && array.reportsProfile[i].reportId === id) {
          removeId = array.reportsProfile[i]._id;
          break;
        }
      }
      if (removeId) {
        await api.delete(`/profile-report/${removeId}`, {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });
      }
    },

    async activateReport(id) {
      await api.post(
        `/profile-report`,
        {
          reportId: id,
          profileId: this.profile._id,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );
    },

    async getReportsForProfile() {
      const responseReport = await api.get('/get-profile-report', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      this.reportsProfile = responseReport.data;

      return this.reportsProfile;
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.fields = [
      {
        key: 'reportName',
        label: `${this.$t('acessProfileTranslateUpdate.especificReportTitle')}`
      },
      {
        key: 'active',
        label: `${this.$t('acessProfileTranslateUpdate.apply')}`
      },
    ];

    const response = await api.get('/profile-report', {
      headers: {
        'x-access-token': this.userAuth.token,
      },
    });

    this.items = response.data;

    const array = await this.getReportsForProfile();

    for (let i = 0; i < this.items.length; i += 1) {
      const index = array.reportsProfile.findIndex(
        (val) =>
          // eslint-disable-next-line
          val.reportId == this.items[i]._id &&
          this.profile._id === val.profileId,
      );
      if (index < 0) {
        this.items[i].active = false;
      } else {
        this.items[i].active = true;
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/organisms/settings/profiles/modal-report-profile.vue